import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { GridApi } from 'ag-grid-community';
import { IstSummaryService } from 'src/app/services/ist/ist-summary.service';
import { MessageBoxComponent } from 'src/app/common/message-box/message-box.component';
import { DeleteBoxComponent } from 'src/app/common/delete-box/delete-box.component';
import { AllRequestsViewModalComponent } from './all-requests-view-modal/all-requests-view-modal.component';
import { FundRequestModalComponent } from './fund-request-modal/fund-request-modal.component';
import { ReturnRetrivalModalComponent } from './return-retrival-modal/return-retrival-modal.component';
import { FundReturnRetrivalModalComponent } from './fund-return-retrival-modal/fund-return-retrival-modal.component';
import { IstDataShareService } from '../../../services/ist/ist-datashare.service';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { CommonService } from '../../../services/common.service';
import { UserService } from '../../../services/user.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';


@Component({
  selector: 'app-ist-all-requests',
  templateUrl: './ist-all-requests.component.html',
  styleUrls: ['./ist-all-requests.component.scss']
})
export class IstAllRequestsComponent implements OnInit {
  columnDefs;
  operations;
  tempoperations;
  gridApi: GridApi;
  selectedRow;
  rowData;
  advanceSearch;
  ApplicationID: string;
  productlist: any = [];
  statuslist: any = [];
  AllRequestSearch: UntypedFormGroup;
  permission: string = "";
  isFundBasedApp: string = "";
  userType: string = "";
  IsPatientsAvailable = "yes";
  typeOptions = [];
  AppStatus:any;
  staticformFields: any;
  isProductBasedApp: string = "";
  collapesedOrNot:boolean=false;
  screenName:string='';
  constructor(
    private router: Router,
    public route: ActivatedRoute,
    private summaryService: IstSummaryService,
    private modalService: NgbModal,
    private datashareService: IstDataShareService,
    private commonService: CommonService,
    private userService: UserService,
  ) {
  }
  getStaticFiledsData(screenCode: string) {
    this.commonService.getScreenStaticFields(screenCode, this.ApplicationID)
      .subscribe(summary => {
        this.staticformFields = summary["Data"];
        if (this.isFundBasedApp == "Y" && this.isProductBasedApp=="Y") {
            this.columnDefs = [
              {
                "headerName": "Request Type",
                "field": "RequestType"
              },
              {
                "headerName": this.staticformFields?.PRODUCT_ID.LABEL_NAME,
                "field": "ProductName"            
              },
              {
                "headerName": "Requested",
                "field": "Requested"
              },
              {
                "headerName": "Allocated",
                "field": "Allocated"
              },
              {
                "headerName": "Used",
                "field": "Used"
              },
              {
                "headerName": "Status",
                "field": "StatusStr"
              }
            ];
          } else {
            this.columnDefs = [
              {
                "headerName": this.staticformFields?.PRODUCT_ID.LABEL_NAME,
                "field": "ProductName"
              },
              {
                "headerName": "Requested",
                "field": "Requested"
              },
              {
                "headerName": "Allocated",
                "field": "Allocated"
              },
              {
                "headerName": "Used",
                "field": "Used"
              },
              {
                "headerName": "Status",
                "field": "StatusStr"
              }
            ];
          }
      });
  }
  ngOnInit() {

    this.datashareService.ApplicationID.subscribe(x => {
      this.ApplicationID = x;
    });
    this.getStaticFiledsData('SCR-007');
    this.GetScreenConfigControls('SCR-007');
    
    this.AllRequestSearch = new UntypedFormGroup({
      RequestID: new UntypedFormControl(null),
      ProductName: new UntypedFormControl(null),
      RequestType: new UntypedFormControl(null),
      Status: new UntypedFormControl(""),
    });

    this.permission = this.commonService.getPagePermission("IST07").toLowerCase();
    if (this.permission == null || this.permission == undefined || this.permission == '') {
      const intervalId = setInterval(() => {
        this.permission = this.commonService.getPagePermission("IST07").toLowerCase();
        if (this.permission != null && this.permission != undefined && this.permission != '') {
            this.getSummary();
          clearInterval(intervalId);
        }
      }, 1000);
    }
    else{
      this.getSummary();
    }
    this.AppStatus =this.commonService.getIstStatus();
    this.userType = this.userService.getUserType();
   

    //this.productlist = [];

    this.statuslist = [
      { "value": "0", "label": "All" },
      { "value": "1", "label": "Draft" },
      { "value": "2", "label": "Submitted" },
      { "value": "3", "label": "Approved" },
      { "value": "4", "label": "Rejected" },
      { "value": "5", "label": "Allocated" },
      { "value": "8", "label": "Withdrawn" },
      { "value": "7", "label": "Closed" },
      { "value": "10", "label": "Return Requested" }      
    ];

    this.typeOptions = [
      { "value": "", "label": "Both" },
      { "value": "Product", "label": "Product" },
      { "value": "Fund", "label": "Fund" }
    ];

    // this.datashareService.ApplicationID.subscribe(x => {
    //   this.ApplicationID = x;
    // });

     this.tempoperations = [

     ];
    // onSetGridApi(params) {
    //   this.gridApi = params.api;
    //   this.gridApi.sizeColumnsToFit();
    // }

    // if (this.permission == "edit") {
    //   this.tempoperations.push({
    //     "name": "Edit",
    //     "id": "edit"
    //   });

    // }

    // this.advanceSearch = {

    // };

    // this.operations = this.tempoperations.map(operation => {
    //   return (operation && (operation.id === 'add' || operation.id === 'view_modal')) ? { name: operation.name, callback: this[operation.id], self: this, disabled: 'false' } : { name: operation.name, callback: this[operation.id], self: this }
    // });


    this.getMasterData();
  }

  onSetGridApi(gridApi) {
    this.gridApi = gridApi;
    this.gridApi.sizeColumnsToFit();
  }

  onCallbackOperation(opr) {
    opr.callback();
  }

  onSelectionChanged(event) {
    this.selectedRow = this.gridApi.getSelectedRows() ? this.gridApi.getSelectedRows()[0] : null;
  }

  onRowDoubleClicked(event) {
    if (event.data['RequestType'] == "Product") {
      let modalRef = this['self'].modalService.open(AllRequestsViewModalComponent, {
        backdrop: false,
        keyboard: false,
        windowClass: 'modal-vlg right modal-right',
        animation: true
      });
      modalRef.componentInstance.Content={
        heading: 'View',
        content: { id: event.data['ID'], ApplicationID: this.ApplicationID }
      }
      //modalRef.content.action.subscribe(result => {
      //  this['self'].getSummary();
      //})
    } else {
      let modalRef1 = this['self'].modalService.open(FundRequestModalComponent, {
        backdrop: false,
        keyboard: false,
        windowClass: 'modal-vlg right modal-right',
        animation: true
      });
      modalRef1.componentInstance.Content= {
        heading: 'View',
        content: { id: event.data['ID'], ApplicationID: this.ApplicationID }
      }
      //modalRef1.content.action.subscribe(result => {
      //  this['self'].getSummary();
      //})
    }

  }

  add_product_request() {
    // if (this.IsPatientsAvailable != "no") {
    let modalRef = this.modalService.open(AllRequestsViewModalComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: 'modal-vlg right modal-right',
      animation: true
    });
    modalRef.componentInstance.Content={
      heading: 'Add',
      content: { id: "", ApplicationID: this.ApplicationID }
    }
    modalRef.result.then(result => {
      this.getSummary();
    })
    // }
    // else {
    //   this.modalService.show(MessageBoxComponent, { data: { heading: 'Validation Message(s)', content: { heading: '', description: 'Please save the Patients first.' } } });
    // }
  }

  edit(Record: any) {
    if (Record['RequestType'] == "Product") {
      let modalRef = this['self'].modalService.open(AllRequestsViewModalComponent, {
        backdrop: false,
        keyboard: false,
        windowClass: 'modal-vlg right modal-right',
        animation: true,
      });
        modalRef.componentInstance.Content={
          heading: 'Edit',
          content: { id: Record['ID'], ApplicationID: this.ApplicationID }
        }
      modalRef.result.then(result => {
        this['self'].getSummary();
      })
    }
    else {
      let modalRef = this['self'].modalService.open(FundRequestModalComponent, {
        backdrop: false,
        keyboard: false,
        windowClass: 'modal-vlg right modal-right',
        animation: true,
      });
        modalRef.componentInstance.Content={
          heading: 'Edit',
          content: { id: Record['ID'], ApplicationID: this.ApplicationID }
        }
      modalRef.result.then(result => {
        this['self'].getSummary();
      })
    }

  }

  getMasterData() {
    this.summaryService.getSummaryData("api/ISTAllRequests/GetSummaryMaster?ApplicationID=" + this.ApplicationID).subscribe(summary => {
      this.productlist = summary["MasterData1"];
      this.productlist = [{ label: "All", value: null, checked: true }].concat(this.productlist);
      if (summary["MasterData2"] != null && summary["MasterData2"] != undefined) {

        this.isFundBasedApp = summary["MasterData2"][1].value;
        this.isProductBasedApp = summary["MasterData2"][0].value;
      }

      if (summary["MasterData3"] != null && summary["MasterData3"] != undefined) {
        this.IsPatientsAvailable = summary["MasterData3"][0].value;
      }

      if (window && window['moduleType'] && window['moduleType'] == "eap") {
        this.operations.map((columnDef, i) => {
          if (columnDef.name === "Add Fund Request") {
            delete this.operations[i]
          }
        })
      }
    });
  }

  getSummary() {
    this.SearchClear();
    this.summaryService.getSummaryData("api/ISTAllRequests/getSummaryData?ApplicationID=" + this.ApplicationID).subscribe(summary => {
      this.rowData = this.setOperations(summary);
    });
  }

  setOperations(RawData: any): any {

    this.setDef(this.tempoperations);
    RawData.forEach(element => {  
      if (element.StatusStr == "Submitted" && this.userType == "I") {
        let tempoperations2 = [
          {
            "name": "View",
            "id": "view"
          },
          {
            "name": "Approve",
            "id": "approve"
          },
          {
            "name": "Reject",
            "id": "reject"
          }
        ];

        element["Operations"] = this.setDef(tempoperations2);
      }
      
      if (element.StatusStr == "Approved" && this.userType == "I") {
        let tempoperations2
        tempoperations2 = [
          {
            "name": "View",
            "id": "view"
          },
          {
            "name": "Allocate",
            "id": "allocate"
          }
        ];

        element["Operations"] = this.setDef(tempoperations2);
      }

      if ((element.StatusStr == "Allocated" || element.StatusStr == "Return Requested") && this.userType == "I") {
        let tempoperations2 = [];
        if (element.Used != null && element.Used != undefined && element.Used != "" && (element.RetrivalQuantity == null || element.RetrivalQuantity == "" || element.RetrivalQuantity == undefined)) {
          tempoperations2.push(
            {
              "name": "View",
              "id": "view"
            },
            {
              "name": "Retrieve",
              "id": "retrieve"
            }
          );
        }
        if ((element.Used == null || element.Used == undefined || element.Used == "") && element.StatusStr == "Allocated") {
          tempoperations2.push({
            "name": "View",
            "id": "view"
          });

          element["Operations"] = this.setDef(tempoperations2);
        }
        if ((element.StatusStr == "Return Requested" || element.StatusStr == "Allocated") && element.RetrivalQuantity != null && element.RetrivalQuantity != "" && element.RetrivalQuantity != undefined) {
          tempoperations2.push({
            "name": "View",
            "id": "view"
          });
        }
        if ((element.StatusStr == "Return Requested" && this.userType == "I" && element.Status == 10)) {
          let isViewExits = tempoperations2.filter(op => {
            return op.id != "view"
          })[0];
          if (!isViewExits) {
            tempoperations2.push({
              "name": "View",
              "id": "view"
            });
          }
        }
        element["Operations"] = this.setDef(tempoperations2);
      }

      if (element.StatusStr == "Returned" && this.userType == "I") {
        if ((element.returnFund != null && element.returnFund != "")) {
          let tempoperations2 = [
            {
              "name": "View",
              "id": "view"
            },
            {
              "name": "Close",
              "id": "close"
            }
          ];

          element["Operations"] = this.setDef(tempoperations2);
        }
      }

      if (element.StatusStr == "Draft" && this.userType == "E") {
        if (this.permission == "new" || this.permission == "edit") {
          this.tempoperations = [
            {
              "name": "Edit",
              "id": "edit"
            },
            {
              "name": "View",
              "id": "view"
            },
            {
              "name": "Delete",
              "id": "delete"
            }
            
          ];
    
          if(this.AppStatus)
            {
              this.tempoperations.push(
                {
                  "name": "Submit",
                  "id": "submit"
                }
              )
             }

        } 

        element["Operations"] = this.setDef(this.tempoperations);
      }      

      if (element.StatusStr == "Submitted" && this.userType == "E") {
        this.tempoperations = [
          {
            "name": "View",
            "id": "view"
          },
          {
            "name": "Withdraw",
            "id": "withdraw"
          }
        ];

        element["Operations"] = this.setDef(this.tempoperations);
      }

      if (this.userType == "E" && (element.StatusStr == "Approved" || element.StatusStr == "Allocated")) {
        this.tempoperations = [
          {
            "name": "View",
            "id": "view"
          }
        ];      
         

        if ((element.Used == null || element.Used == "" || element.Used == undefined) && element.StatusStr == "Allocated") {
          this.tempoperations.push(            
            {
              "name": "Edit",
              "id": "edit"
            },
            {
              "name": "Withdraw",
              "id": "withdraw"
            },
            {
              "name": "Request Return",
              "id": "requestReturn"
            }
          );
        }

        if (element.StatusStr == "Approved") {
          this.tempoperations.push(   
            {
              "name": "Withdraw",
              "id": "withdraw"
            }
          );
        }

        element["Operations"] = this.setDef(this.tempoperations);
      }

      if (element.StatusStr == "Return Requested"  && this.userType == "E"){
        this.tempoperations = [
          {
            "name": "View",
            "id": "view"
          }
        ];

        element["Operations"] = this.setDef(this.tempoperations);
      }

      if (element.StatusStr == "Returned"  && this.userType == "E"){
        this.tempoperations = [
          {
            "name": "View",
            "id": "view"
          },
          {
            "name": "Withdraw",
            "id": "withdraw"
          }
        ];

        element["Operations"] = this.setDef(this.tempoperations);
      }
      
      if (element.RetrivalQuantity != null && element.RetrivalQuantity != "" && element.RetrivalQuantity != undefined && (element.StatusStr == "Allocated" || element.StatusStr == "Return Requested") && this.userType == "E") {
        this.tempoperations = [
          {
            "name": "View",
            "id": "view"
          },         
          {
            "name": "Return",
            "id": "returnrequest"
          }
        ];

        element["Operations"] = this.setDef(this.tempoperations);
      }

      if (element.StatusStr == "Closed" || element.StatusStr == "Withdrawn" || element.StatusStr == "Rejected") {
        this.tempoperations = [
          {
            "name": "View",
            "id": "view"
          }
        ];

        element["Operations"] = this.setDef(this.tempoperations);
      }

      if (element.Allocated != null && element.Allocated != "" && element.Allocated != undefined &&
        element.Used != null && element.Used != "" && element.Used != undefined) {
        if (element.Allocated == element.Used && this.userType=="I") {
          let tempoperations2 = [
            {
              "name": "View",
              "id": "view"
            },
            {
              "name": "Close",
              "id": "close"
            }
          ];

          element["Operations"] = this.setDef(tempoperations2);
        }
      }

      if (this.permission == "view") {
        this.tempoperations = [          
          {
            "name": "View",
            "id": "view"
          }
        ];

        element["Operations"] = this.setDef(this.tempoperations);
      } 
       
    });

    setTimeout(()=>{
      this.gridApi.sizeColumnsToFit();
      },500);
    return RawData;
  }

  setDef(parmoperations: any): any {
    //this.tempoperations = parmoperations;
    this.operations = parmoperations.map(operation => {
      return operation &&
        (operation.id === "add" || operation.id === "view_modal")
        ? {
          name: operation.name,
          callback: this[operation.id],
          self: this,
          disabled: "false"
        }
        : { name: operation.name, callback: this[operation.id], self: this };
    });
    return this.operations;
  }

  setSummarySearch(searchObject) {
    this.summaryService.fetchSearchData("api/ISTAllRequests/getSummarySearchData", searchObject).subscribe(summary => {
      this.rowData = summary;
    });
  }

  add_fund_request() {
    let modalRef = this.modalService.open(FundRequestModalComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: 'modal-vlg right modal-right',
      animation: true
    });
    modalRef.componentInstance.Content={
      heading: 'Add',
      content: { id: "", ApplicationID: this.ApplicationID }

    }
    modalRef.result.then(result => {
      this.getSummary();
    })
  }

  view(Record: any) {
    if (Record['RequestType'] == "Product") {
      let modalRef = this['self'].modalService.open(AllRequestsViewModalComponent, {
        backdrop: false,
        keyboard: false,
        windowClass: 'modal-vlg right modal-right',
        animation: true,
      });
      modalRef.componentInstance.Content= {
          heading: 'View',
          content: {
            id: Record['ID'],
            ReturnAmount: Record['WithOutSymbolUsed'] == null? Record['WithOutSymbolAllocated'] : Record['WithOutSymbolAllocated'] - Record['WithOutSymbolUsed'],
            RetrieveVia: Record['RetrieveType'],
            UsedFund: Record['Used'],
            ReturnFund: Record['returnFund']
          }
        }

    } else {
      let modalRef1 = this['self'].modalService.open(FundRequestModalComponent, {
        backdrop: false,
        keyboard: false,
        windowClass: 'modal-vlg right modal-right',
        animation: true,
      });
        modalRef1.componentInstance.Content={
          heading: 'View',
          content: {
            id: Record['ID'],
            ReturnAmount: Record['WithOutSymbolUsed'] == null? Record['WithOutSymbolAllocated'] : Record['RetrivalFund'],
            RetrieveVia: Record['RetrieveType'],
            UsedFund: Record['Used'],
            ReturnFund: Record['returnFund']
          }
        }

    }
  }

  delete(Record: any) {
    if (Record['Status'] < 2) {
      let id = Record['ID'];
      let Type = Record['RequestType'];
      let modalRef = this["self"].modalService.open(DeleteBoxComponent,  {backdrop: false});
      modalRef.componentInstance.Content= { heading: 'Delete',custommessage: 'Are you sure you want to delete ?', ProceedButtonName: "Delete", TerminateButtonName: "Cancel"};
      modalRef.result.then(result => {
        if (result == "okclick") {
          this['self'].summaryService.DeleteRecord('api/ISTAllRequests/Delete?RecordID=' + id).subscribe(summary => {
            if (summary["Status"] == 0) {
              // this['self'].toastrService.success("Selected Record(s) has been Deleted.");
              this['self'].commonService.SuccessBanner(this['self'].screenName + " deleted successfully")
              this['self'].getSummary();
            }
            else {
              //this['self'].toastrService.error("Error Occurred while Deleting the record.Please try again after sometime.");
              this.commonService.ErrorBanner("Error Occurred while Deleting the record.Please try again after sometime.");
            }
          });
        }
      });
    }
    else {
      //this['self'].modalService.show(MessageBoxComponent, { data: { heading: 'Validation Message(s)', content: { heading: '', description: 'Selected operation is not Possible for current Record.' } } });
      this.commonService.ValidationBanner("The submitted request cannot be deleted");
      // this['self'].modalService.show(MessageBoxComponent, { data: { heading: 'Validation Message(s)', content: { heading: '', description: 'The submitted request cannot be delete' } } });
    }
  }

  approve(Record: any) {
    if (Record['Status'] == 2) {
      this['self'].summaryService.getSummaryData("api/ISTAllRequests/Approve?RecordID=" + Record["ID"]).subscribe(summary => {
        // this['self'].modalRef = this['self'].modalService.show(MessageBoxComponent, {
        //   backdrop: false,
        //   keyboard: false,
        //   ignoreBackdropClick: true,
        //   animated: true,
        //   // data: { heading: 'Approve', content: { heading: '', description: 'The request has been Approved.' } }
        // });
        this['self'].commonService.SuccessBanner(this['self'].screenName + " has been approved");
        this['self'].getSummary();
      })
    }
    else {
      this['self'].commonService.ValidationBanner("Selected operation is not Possible for current Record");
      // modalserive.show(MessageBoxComponent, { data: { heading: 'Validation Message(s)', content: { heading: '', description: 'Selected operation is not Possible for current Record.' } } });
    }

  }

  submit(Record: any) {
    // || (this['self'].selectedRow['ParentId'] != undefined && this['self'].selectedRow['RequiredBy'] <= Date.now)
    if (Record['Status'] < 2) {
      this['self'].summaryService.getSummaryData("api/ISTAllRequests/Submit?RecordID=" + Record["ID"]).subscribe(summary => {
        // this['self'].modalRef = this['self'].modalService.show(MessageBoxComponent, {
        //   backdrop: false,
        //   keyboard: false,
        //   ignoreBackdropClick: true,
        //   animated: true,
        //   data: { heading: 'Approve', content: { heading: '', description: 'The request has been Submitted.' } }
        // });
        this['self'].commonService.SuccessBanner(this["self"].screenName + " has been Submitted")
        this['self'].getSummary();
      })
    }
    else {
      this.commonService.ValidationBanner("Selected operation is not Possible for current Record");
      // modalserive.show(MessageBoxComponent, { data: { heading: 'Validation Message(s)', content: { heading: '', description: 'Selected operation is not Possible for current Record.' } } });
    }
  }

  reject(Record: any) {
    if (Record['Status'] == 2) {

      this['self'].summaryService.getSummaryData("api/ISTAllRequests/Reject?RecordID=" + Record["ID"]).subscribe(summary => {
        // this['self'].modalRef = this['self'].modalService.show(MessageBoxComponent, {
        //   backdrop: false,
        //   keyboard: false,
        //   ignoreBackdropClick: true,
        //   animated: true,
        //   // data: { heading: 'Reject', content: { heading: '', description: 'The request has been Rejected.' } }
        // });
        this['self'].commonService.SuccessBanner(this['self'].screenName + " has been rejected");
        this['self'].getSummary();
      });
    }
    else {
      this['self'].commonService.ValidationBanner("Selected operation is not Possible for current Record");
      // modalserive.show(MessageBoxComponent, { data: { heading: 'Validation Message(s)', content: { heading: '', description: 'Selected operation is not Possible for current Record.' } } });
    }

  }

  requestReturn(Record: any) {
    let modalRef = this["self"].modalService.open(DeleteBoxComponent, {backdrop: false});
    if (Record['RequestType'] == "Product") {
      modalRef.componentInstance.Content = { header: 'Confirmation', custommessage: 'Do you want to return the product?', ProceedButtonName: "Yes", TerminateButtonName: "No"  };
    } else {
      modalRef.componentInstance.Content = { header: 'Confirmation', custommessage: 'Do you want to return the fund?', ProceedButtonName: "Yes", TerminateButtonName: "No"  };
    }
    modalRef.result.then(result => {
      if (result == "okclick") {
        this['self'].summaryService.getSummaryData("api/ISTAllRequests/RequestReturn?RecordID=" + Record["ID"]).subscribe(summary => {
          this['self'].commonService.SuccessBanner("Return request submitted successfully");
          this['self'].getSummary();
        });
      }
    });
  }

  close(Record: any) {
    if (Record['Status'] > 3) {
      const modalRef = this["self"].modalService.open(DeleteBoxComponent, {backdrop: false});
      modalRef.componentInstance.Content={ header: 'Close', custommessage: 'You are about to close the request. Do you want to proceed?', ProceedButtonName: "Yes", TerminateButtonName: "Cancel" };
      modalRef.result.then(result => {
        if (result == "okclick") {
          this['self'].summaryService.getSummaryData("api/ISTAllRequests/Close?RecordID=" + Record["ID"]).subscribe(summary => {
            if (summary != null && summary.Message == "N") {
              if (Record['RequestType'] == "Product") {
                this.commonService.ValidationBanner("Selected operation is not Possible Please Adjust Product ");
                // modalserive.show(MessageBoxComponent, { data: { heading: 'Validation Message(s)', content: { heading: '', description: 'Selected operation is not Possible Please Adjust Product .' } } });

              }
              else {
                this.commonService.ValidationBanner("Selected operation is not Possible Please Adjust Fund");
                // modalserive.show(MessageBoxComponent, { data: { heading: 'Validation Message(s)', content: { heading: '', description: 'Selected operation is not Possible Please Adjust Fund.' } } });
              }
            }
            else {
              this['self'].commonService.SuccessBanner(this['self'].screenName + " has been closed");
              this['self'].getSummary();
            }

          });
        }
      });
    }
    else {
      this.commonService.ValidationBanner("Selected operation is not Possible for current Record");
      // modalserive.show(MessageBoxComponent, { data: { heading: 'Validation Message(s)', content: { heading: '', description: 'Selected operation is not Possible for current Record.' } } });
    }

  }

  allocate(Record: any) {
    if (Record['Status'] == 3) {
      if (Record["Allocated"] != null && Record["Allocated"] != "" && Record["Allocated"] != undefined) {
        this['self'].summaryService.getSummaryData("api/ISTAllRequests/Allocate?RecordID=" + Record["ID"]).subscribe(summary => {
          // this['self'].modalRef = this['self'].modalService.show(MessageBoxComponent, {
          //   backdrop: false,
          //   keyboard: false,
          //   ignoreBackdropClick: true,
          //   animated: true,
          //   // data: {
          //   //   heading: 'Allocated',
          //   //   content: { heading: '', description: 'The product request has been Allocated.' }
          //   // }
          // });
          this['self'].commonService.SuccessBanner(this['self'].screenName + " updated successfully");
          this['self'].getSummary();
        });
      }
      else {
        if (Record['RequestType'] == "Product") {
          let modalRef = this['self'].modalService.open(AllRequestsViewModalComponent, {
            backdrop: false,
            keyboard: false,
            windowClass: 'modal-vlg right modal-right',
            animation: true,
          });
            modalRef.componentInstance.Content= {
              heading: 'Allocate',
              content: { id: Record['ID'], ApplicationID: this.ApplicationID, AllocatedAmount: Record["Allocated"] }
            }
          modalRef.result.then(result => {
          //  if (result.Status == 0) {
              // summarySer.getSummaryData("api/ISTAllRequests/Allocate?RecordID=" + this['self'].selectedRow["ID"]).subscribe(summary => {

              //   //this['self'].commonService.SuccessBanner("Request details updated successfully");
              //   this['self'].getSummary();
              // });
              this['self'].getSummary();
            //}
          })
        }
        else {
          let modalRef = this['self'].modalService.open(FundRequestModalComponent, {
            backdrop: false,
            keyboard: false,
            windowClass: 'modal-vlg right modal-right',
            animation: true,
          });
            modalRef.componentInstance.Content= {
              heading: 'Allocate',
              content: { id: Record['ID'], ApplicationID: this.ApplicationID, AllocatedAmount: Record["Allocated"] }
            }
          modalRef.result.then(result => {
           // if (result.Status == 0) {
              // summarySer.getSummaryData("api/ISTAllRequests/Allocate?RecordID=" + this['self'].selectedRow["ID"]).subscribe(summary => {

              //   //this['self'].commonService.SuccessBanner("Request details updated successfully");
              //   this['self'].getSummary();
              // });
              this['self'].getSummary();
           // }            
          })
        }
      }


    }
    else {
      this.commonService.ValidationBanner("Selected operation is not Possible for current Record");
      // modalserive.show(MessageBoxComponent, { data: { heading: 'Validation Message(s)', content: { heading: '', description: 'Selected operation is not Possible for current Record.' } } });
    }
  }

  returnrequest(Record: any) {
    if (Record['Status'] == 5 || Record['Status'] == 10) {
      if (Record["returnFund"] != null && Record["returnFund"] != "" && Record["returnFund"] != undefined) {
        this.commonService.SuccessBanner("Return details shared successfully");
        this['self'].getSummary();
      }
      else {
        if (Record['RequestType'] == "Product") {
          let modalRef = this['self'].modalService.open(AllRequestsViewModalComponent, {
            backdrop: false,
            keyboard: false,
            windowClass: 'modal-vlg right modal-right',
            animation: true,
          });
            modalRef.componentInstance.Content={
              heading: 'Return',
              content: {
                id: Record['ID'], ApplicationID: this.ApplicationID,
                ReturnAmount: Record['WithOutSymbolUsed'] == null? Record['WithOutSymbolAllocated'] : Record['WithOutSymbolAllocated'] - Record['WithOutSymbolUsed'],
                RetrieveVia: Record['RetrieveType']
              }
            }
          modalRef.result.then(result => {
            if (result.Status == 0) {
              // summarySer.getSummaryData("api/ISTAllRequests/ReturnRequest?RecordID=" + this['self'].selectedRow["ID"]).subscribe(summary => {
              //   this['self'].getSummary();
              // });
              this['self'].getSummary();
            }
          })
        }
        else {
          let modalRef = this['self'].modalService.open(FundRequestModalComponent, {
            backdrop: false,
            keyboard: false,
            windowClass: 'modal-vlg right modal-right',
            animation: true,
          });
            modalRef.componentInstance.Content={
              heading: 'Return',
              content: {
                id: Record['ID'], ApplicationID: this.ApplicationID,
                ReturnAmount: Record['WithOutSymbolUsed'] == null? Record['WithOutSymbolAllocated'] : Record['RetrivalFund'],
                UsedFund: Record['Used'],
                RetrieveVia: Record['RetrieveType']
              }
            }
          modalRef.result.then(result => {
            if (result.Status == 0) {
              // summarySer.getSummaryData("api/ISTAllRequests/ReturnRequest?RecordID=" + this['self'].selectedRow["ID"]).subscribe(summary => {
              //   this['self'].getSummary();
              // });
              this['self'].getSummary();
            }
          })
        }
      }
    }
    else {
      this.commonService.ValidationBanner("Selected operation is not Possible for current Record");
      // modalserive.show(MessageBoxComponent, { data: { heading: 'Validation Message(s)', content: { heading: '', description: 'Selected operation is not Possible for current Record.' } } });
    }
  }

  retrieve(Record: any) {
    if (Record['Status'] == 5 || Record['Status'] == 10) {
      if (Record['RequestType'] == "Product") {
        let modalRef = this['self'].modalService.open(ReturnRetrivalModalComponent, {
          backdrop: false,
          keyboard: false,
          windowClass: 'modal-md right modal-right',
          animation: true,
        });
          modalRef.componentInstance.Content={
            heading: null,
            content: {
              id: Record['ID'],
              ApplicationID: this.ApplicationID,
              Allocated: Record["Allocated"],
              ProductUnits: Record["ProductUnits"],
              ReturnAmount: Record['WithOutSymbolUsed'] == null? Record['WithOutSymbolAllocated'] : Record['WithOutSymbolAllocated'] - Record['WithOutSymbolUsed'],
            }
          }
        modalRef.result.then(result => {
          this['self'].getSummary();
        })
      }
      else {
        let modalRef = this['self'].modalService.open(FundReturnRetrivalModalComponent, {
          backdrop: false,
          keyboard: false,
          windowClass: 'modal-md right modal-right',
          animation: true,
        });
          modalRef.componentInstance.Content= {
            heading: null,
            content: {
              id: Record['ID'],
              ApplicationID: this.ApplicationID,
              Allocated: Record["WithOutSymbolAllocated"],
              ReturnAmount: Record['WithOutSymbolUsed'] == null? Record['WithOutSymbolAllocated'] : Record['RetrivalFund'],
           }
          }
        modalRef.result.then(result => {
          this['self'].getSummary();
        })
      }

    }
    else {
      this.commonService.ValidationBanner("Selected operation is not Possible for current Record");
      // modalserive.show(MessageBoxComponent, { data: { heading: 'Validation Message(s)', content: { heading: '', description: 'Selected operation is not Possible for current Record.' } } });
    }
  }

  retrieve_fund() {
    let modalRef = this['self'].modalService.open(FundReturnRetrivalModalComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: 'modal-md right modal-right',
      animation: true,
    });
      modalRef.componentInstance.Content= {
        heading: null,
        content: { id: this['self'].selectedRow['ID'] }

      }
  }

  withdraw(Record: any) {
    // if (this['self'].selectedRow['Status'] == ) {
      if(Record['Status'] == 5 || Record['Status'] == 6){
        if (Record['RequestType'] == "Product"){
          this['self'].commonService.ValidationBanner("To withdraw the request please raise return request for the allocated Product");
        } else{
          this['self'].commonService.ValidationBanner("To withdraw the request please raise return request for the allocated Fund");
        }
      } else{
        this['self'].summaryService.getSummaryData("api/ISTAllRequests/WithDraw?RecordID=" + Record["ID"]).subscribe(summary => {
          this['self'].commonService.SuccessBanner("The request has been withdrawn Successfully");
          this['self'].getSummary();
        });
      }
    
    // }
    // else {
    //   modalserive.show(MessageBoxComponent, { data: { heading: 'Validation Message(s)', content: { heading: '', description: 'Selected operation is not Possible for current Record.' } } });
    // }
  }


  

  SearchClear() {
    this.AllRequestSearch?.reset();
    //  this.setSummary();
  }

  AdvanceSearch() {
    var formData = this.AllRequestSearch.value;
    formData["ApplicationID"] = this.ApplicationID;
    if (formData["Status"] != "" && formData["Status"] != undefined && formData["Status"] != null) {
      formData["Status"] = parseInt(formData["Status"]);
    }
    this.setSummarySearch(formData);
  }

  GetScreenConfigControls(screenCode: string) {
    this.commonService.GetScreenConfigControls(screenCode, this.ApplicationID, '',(ScreenData) => {
      this.screenName= ScreenData.NAME;
    });
  }
}
